function handleScriptLoad(autoCompleteRef, validateAddressObject) {
  if (autoCompleteRef.current) {
    // Create the autocomplete instance
    const autocomplete = new window.google.maps.places.Autocomplete(
      autoCompleteRef.current,
      {
        // types: ["address"],
        types: ['geocode'],
        componentRestrictions: { country: "us" },
      }
    );

    // Store the autocomplete instance on the input element
    autoCompleteRef.current._autocomplete = autocomplete;

    // Set up the place_changed event listener
    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      
      if (place && place.geometry && place.geometry.location) {
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        
        const addressComponents = extractAddressComponents(place.address_components || []);
        
        const formattedAddress = {
          street_number: addressComponents.street_number,
          street: addressComponents.route,
          city: addressComponents.locality,
          state: addressComponents.administrative_area_level_1,
          county: addressComponents.administrative_area_level_2,
          zip: addressComponents.postal_code,
          country: addressComponents.country,
          latitude,
          longitude,
          place_id: place.place_id,
          url: place.url,
          formatted_address: place.formatted_address,
          full_address: place.formatted_address,
        };
        
        // Mark that we have a Google selection - set flag BEFORE calling validateAddressObject
        autoCompleteRef.current._hasGoogleSelection = true;
        
        // Call the validation function
        validateAddressObject(formattedAddress);
      }
    });

    // Add more event listeners for better detection of place selection
    const input = autoCompleteRef.current;
    
    // Track when predictions are showing
    let isDropdownVisible = false;
    autocomplete.addListener("predictions_changed", () => {
      isDropdownVisible = true;
    });
    
    // Track when predictions are hidden
    autocomplete.addListener("place_changed", () => {
      isDropdownVisible = false;
    });

    // Handle click events on the input to catch selection
    input.addEventListener('click', (e) => {
      // Check if a selection was made after a short delay
      setTimeout(() => {
        if (input._hasGoogleSelection) {
          // Reset the flag
          input._hasGoogleSelection = false;
        }
      }, 100);
    });

    // Handle keydown events to prevent form submission when dropdown is open
    input.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && isDropdownVisible) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  }
}

// Helper function to extract address components
function extractAddressComponents(components) {
  const addressComponents = {
    street_number: "",
    route: "",
    locality: "",
    administrative_area_level_1: "",
    administrative_area_level_2: "",
    postal_code: "",
    country: "",
  };

  components.forEach((component) => {
    const types = component.types;
    
    if (types.includes("street_number")) {
      addressComponents.street_number = component.long_name;
    }
    if (types.includes("route")) {
      addressComponents.route = component.long_name;
    }
    if (types.includes("locality")) {
      addressComponents.locality = component.long_name;
    }
    if (types.includes("administrative_area_level_1")) {
      addressComponents.administrative_area_level_1 = component.short_name;
    }
    if (types.includes("administrative_area_level_2")) {
      addressComponents.administrative_area_level_2 = component.long_name;
    }
    if (types.includes("postal_code")) {
      addressComponents.postal_code = component.long_name;
    }
    if (types.includes("country")) {
      addressComponents.country = component.short_name;
    }
  });

  return addressComponents;
}

// Function to geocode manually typed addresses
async function manuallyGeocode(address, validateAddressObject, delay = 500) {
  const geocoder = new window.google.maps.Geocoder();
  
  // Wait for the specified delay to give Google autocomplete priority
  await new Promise(resolve => setTimeout(resolve, delay));
  
  geocoder.geocode({ address }, (results, status) => {
    if (status === "OK" && results && results.length > 0) {
      const result = results[0];
      
      if (result.geometry && result.geometry.location) {
        const latitude = result.geometry.location.lat();
        const longitude = result.geometry.location.lng();
        
        const addressComponents = extractAddressComponents(result.address_components || []);
        
        const formattedAddress = {
          street_number: addressComponents.street_number,
          street: addressComponents.route,
          city: addressComponents.locality,
          state: addressComponents.administrative_area_level_1,
          county: addressComponents.administrative_area_level_2,
          zip: addressComponents.postal_code,
          country: addressComponents.country,
          latitude,
          longitude,
          place_id: result.place_id,
          formatted_address: result.formatted_address,
          full_address: result.formatted_address,
        };
        
        validateAddressObject(formattedAddress);
      }
    }
  });
}

export { handleScriptLoad, manuallyGeocode };
